import React from 'react';
import { createPortal } from 'react-dom';
import { isIosNonSafari } from '../pwa/pwaInstallUtils';

export function PwaAndroidInstallModal({ show, onClose }) {
  if (!show) return null;

  return createPortal(
    <div
      className="modal fade show d-block pwa-install-ios-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="pwa-install-android-title"
      tabIndex={-1}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content shadow">
          <div className="modal-header border-0 pb-0">
            <h2 className="modal-title h5" id="pwa-install-android-title">
              Install Saloni Designs
            </h2>
            <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
          </div>
          <div className="modal-body pt-2">
            <ol className="pwa-install-ios-modal__steps small mb-0">
              <li>
                Tap the browser menu <strong>⋮</strong> (top right in Chrome).
              </li>
              <li>
                Choose <strong>Install app</strong> or <strong>Add to Home screen</strong>.
              </li>
              <li>Confirm — the app icon will appear on your home screen.</li>
            </ol>
          </div>
          <div className="modal-footer border-0 pt-0">
            <button type="button" className="btn btn-wine w-100" onClick={onClose}>
              Got it
            </button>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" onClick={onClose} aria-hidden />
    </div>,
    document.body
  );
}

export function PwaIosInstallModal({ show, onClose }) {
  if (!show) return null;

  const openInSafari = isIosNonSafari();

  return createPortal(
    <div
      className="modal fade show d-block pwa-install-ios-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="pwa-install-ios-title"
      tabIndex={-1}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content shadow">
          <div className="modal-header border-0 pb-0">
            <h2 className="modal-title h5" id="pwa-install-ios-title">
              Add Saloni Designs to your home screen
            </h2>
            <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
          </div>
          <div className="modal-body pt-2">
            {openInSafari ? (
              <p className="small text-muted mb-3">
                For the install option, open this site in <strong>Safari</strong> first (copy the
                link from your browser&apos;s menu if needed).
              </p>
            ) : null}
            <ol className="pwa-install-ios-modal__steps small mb-0">
              <li>
                Tap the Share button{' '}
                <span className="pwa-install-ios-modal__share-icon" aria-hidden>
                  ↑
                </span>{' '}
                at the bottom of Safari (or the top bar on iPad).
              </li>
              <li>
                Scroll the menu and choose <strong>Add to Home Screen</strong>.
              </li>
              <li>
                Tap <strong>Add</strong> — the Saloni Designs icon will appear on your home screen
                like an app.
              </li>
            </ol>
          </div>
          <div className="modal-footer border-0 pt-0">
            <button type="button" className="btn btn-wine w-100" onClick={onClose}>
              Got it
            </button>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" onClick={onClose} aria-hidden />
    </div>,
    document.body
  );
}
